import { filter, first, mergeMap } from 'rxjs/operators';
import { TopicFollowersDetails } from '../digestReader/topicFollowersDetails.component';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PermissionService, StreamService, TenantService, UserService } from '../services'
import { EmailAddressDialogComponent } from '../general/emailAddressDialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FollowConfirmationSnackbarMessageComponent } from './followConfirmationSnackbarMessage.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { JamBottomSheetComponent } from '../general/jamBottomSheet.component';

@Component({
    selector: 'topic-summary',
    styles: [`
        a.topic-link {
            text-decoration: none;
        }

        a.topic-link:hover {
            text-decoration: underline;
        }

        .back-link {
            padding-bottom: 12px;
        }

        .trim-container {
           min-width: 0px;
        }
        
        .image-row {
            min-height: 88px;
        }

        .description {
            padding-bottom: 10px;
            height: 50px; 
            overflow: hidden;
        }
        
        .user-count {
            padding-left: 5px; 
            padding-right: 8px;
        }
        
        .item-count {
            padding-left: 15px;
            padding-right: 8px;
        }
        
        .count-wrapper {
            display: inline-block;
            padding-right: 15px;
        }

        .count {
            font-align: center;
        }

        h6 {
            margin-top: 0px;
            margin-bottom: 0px;
        }
    `],
    template: `
        <mat-card style="padding-top: 12px; padding-bottom: 0px;">
            <mat-card-content style="padding-bottom: 0px; margin-bottom: 0px;">
                <div fxFlex="100" fxFlexFill fxLayout="row" class="image-row">
                    <div style="padding-right:7px; margin-left: -15px; margin-top: -12px;">
                        <span *ngIf="!showTopicLink">
                            <topic-image [topic]="topic"></topic-image>    
                        </span>
                        <span *ngIf="showTopicLink">
                            <a [routerLink]="[linkPath + 'topics', topic.id]" style="text-decoration: none;">
                                <topic-image [topic]="topic"></topic-image>
                            </a>
                        </span>
                    </div>
                    <div fxFlex fxLayout="column" class="trim-container">
                        <mat-card-title *ngIf="!showTopicLink" fxFlex="10px" [matTooltip]="topic.title">
                            <div style="overflow: hidden; white-space: nowrap;">
                                <h6 style="text-overflow: ellipsis; overflow: hidden;">{{topic.title}}</h6>
                            </div>
                        </mat-card-title>
                        <mat-card-title *ngIf="showTopicLink" fxFlex="10px" [matTooltip]="topic.title">
                            <div style="overflow: hidden; white-space: nowrap;">
                                <h6 style="text-overflow: ellipsis; overflow: hidden;"><a [routerLink]="[linkPath + 'topics', topic.id]" class="topic-link" >{{topic.title}}</a></h6>
                            </div>
                        </mat-card-title>
                        <div style="padding-top: 4px;">
                            <div fxFlex class="description">{{topic.description}}</div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions style="padding-top: 0px; padding-bottom: 5px;">
                <div *ngIf="currentUser() && showFollowers && !showTopicLink && !isPublicTenant" matTooltip="{{topic.followersCount}} Followers" style="padding-right:25px; padding-left: 8px;">
                    <a (click)="showFollowerDetails()" style="cursor: pointer;">
                        <i class="material-icons" style="font-size: 18px;">supervisor_account</i>
                        <div class="count" style="font-size: 12px; text-align: center;">{{topic.followersCount}}</div>
                    </a>
                </div>
                <div *ngIf="currentUser() && !showFollowers && !showTopicLink && !isPublicTenant" matTooltip="{{topic.followersCount}} Followers" style="padding-right:25px; padding-left: 8px;">
                    <i class="material-icons" style="font-size: 18px;">supervisor_account</i>
                    <div class="count" style="font-size: 12px; text-align: center;">{{topic.followersCount}}</div>
                </div>
                <span fxFlex></span>
                <span *ngIf="!showTopicLink">
                    <button mat-button
                            [matTooltip]="'Sorted by ' + (sortField === 'publishedDate' ? 'Published Date' : 'Attention Rank')"
                            color="primary" 
                            [matMenuTriggerFor]="menu"><mat-icon>filter_list</mat-icon></button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item 
                                matTooltip="by Published Date"
                                [disabled]="sortField === 'publishedDate'"
                                (click)="sorted.emit('publishedDate')"><mat-icon>schedule</mat-icon>Time</button>
                        <button mat-menu-item
                                matTooltip="by Attention Rank"
                                [disabled]="sortField === 'attentionRank'" 
                                (click)="sorted.emit('attentionRank')"><mat-icon>photo_filter</mat-icon>Rank</button>
                    </mat-menu>
                </span>
                <a *ngIf="showTopicLink" [routerLink]="[linkPath + 'topics', topic.id]" style="padding-top: 7px;">Preview</a>
                <button mat-button *ngIf="!showTopicLink && currentUser() && topic.conversationUrl" matTooltip="Jam out man" (click)="showJam()"><mat-icon>podcasts</mat-icon></button>
                <button mat-button *ngIf="!showTopicLink && currentUser() && canEditSource()" matTooltip="Edit {{topic.title}}" [routerLink]="['/settings/sources', topic.id]"><mat-icon>build</mat-icon></button>
                <button mat-button *ngIf="!showTopicLink && currentUser() && canInviteToTopic()" matTooltip="Invite to {{topic.title}}" [routerLink]="['/topics', topic.id, 'invite']"><mat-icon>person_add</mat-icon></button>
                <button mat-button *ngIf="!showTopicLink && currentUser() && canEditTopic()" matTooltip="Edit {{topic.title}}" [routerLink]="['/topics', topic.id]"><mat-icon>build</mat-icon></button>
                <button mat-raised-button *ngIf="currentUser() && topic.userIsFollowing" matTooltip="Remove from Briefing" (click)="toggleSubscription()" style="height: 33px;">Remove from Briefing</button>
                <button mat-raised-button *ngIf="!currentUser() && isPublicTenant" color="primary" matTooltip="Add to My Briefing" (click)="publicSubscribe()" color="primary" style="height: 33px;">Add to My Briefing</button>
                <button mat-raised-button *ngIf="currentUser() && !topic.userIsFollowing && userCanRead()" color="primary" matTooltip="Add to My Briefing" (click)="toggleSubscription()" color="primary" style="height: 33px;">Add to My Briefing</button>
                <span *ngIf="currentUser() && !topic.userIsFollowing && !userCanRead() && isProductAndRestricted()" [matTooltip]="productTooltip()">
                    <button mat-raised-button
                            color="primary" 
                            [disabled]="isOversubscribedProduct()" 
                            (click)="registerAndSubscribe()" 
                            color="primary">
                        Add to My Briefing
                    </button>
                </span>
            </mat-card-actions>
        </mat-card>
    `})
export class TopicSummaryComponent implements OnInit {
    @Input() topic: any;
    @Input() showTopicLink: boolean = false;
    @Input() sortField: any;
    @Input() linkPath = './';
    @Output() sorted = new EventEmitter<string>()
    tenant: any;
    showFollowers: boolean = false;
    isPublicTenant: boolean;

    constructor(private dialog: MatDialog,
                private snackbar: MatSnackBar,
                private bottomSheet: MatBottomSheet,
                private permissionService: PermissionService, 
                private streamService: StreamService, 
                private tenantService: TenantService, 
                private userService: UserService){};

    publicSubscribe(): void {
        this.dialog.open(EmailAddressDialogComponent, {
            data: {
                title: `${this.topic.title}`,
                instructions: [
                    `Enter your email and select follow. Then check your email for confirmation.`
                ],
                actionLabel: `Add to My Briefing`
            }
        }).afterClosed().pipe(
            filter(res => !!res),
            mergeMap((emailAddress: string) => this.streamService.publicSubscribe(this.topic.id, this.topic.title, emailAddress))
        )
        .subscribe(() => this.snackbar.openFromComponent(FollowConfirmationSnackbarMessageComponent));

    }

    toggleSubscription(): void { 
        this.streamService.setSubscription(this.topic.id, this.userService.getCurrentUser().id, !this.topic.userIsFollowing).pipe(first())
        .subscribe(() => {
            this.topic.userIsFollowing ? this.topic.followersCount-- : this.topic.followersCount++;
            this.topic.userIsFollowing = !this.topic.userIsFollowing;
            this.streamService.streamUpdated(this.topic);
        });
    }

    registerAndSubscribe = () => this.streamService.addStreamRole(this.userService.getCurrentUser().id, this.topic.id, 'STREAM_SUBSCRIBER')
        .pipe(
            mergeMap(() => this.userService.refetchUser()),
            mergeMap(() => this.streamService.setSubscription(this.topic.id, this.userService.getCurrentUser().id, true)),
            first()
        ).subscribe(results => {
            this.topic.userIsFollowing ? this.topic.followersCount-- : this.topic.followersCount++;
            this.topic.userIsFollowing = !this.topic.userIsFollowing;
            this.streamService.streamUpdated(this.topic);
        })

    userCanRead(): boolean {
        return this.permissionService.currentUserCanRead(this.topic, true, this.isProduct());
    }

    currentUser = () => this.userService.getCurrentUser();

    showFollowerDetails = () => this.dialog.open(TopicFollowersDetails, { data: this.topic });

    isProduct(): boolean {
        return this.topic && this.topic.type === 'PRODUCT_SOURCE';
    } 

    isProductAndRestricted(): boolean {
        return this.isProduct() && this.tenant.settings.limitProductSources === 'true' && !this.topic.userHasStreamSubscriberRole;
    }

    isOversubscribedProduct(): boolean {
        return this.isProduct() && this.topic.streamSubscribersCount >= this.topic.maxStreamSubscribers
    }

    productTooltip = () => this.isOversubscribedProduct() ? 
        `This source for ${this.topic.title} requires you to register to view content and is currently over subscribed. Please contact your site administrator.` : 
        'Add to My Briefing';

    canInviteToTopic = (): boolean => this.topic && this.permissionService.currentUserCanCreateStream();

    canEditSource = (): boolean => {
        return this.topic &&
               this.topic.tenantId &&
               this.topic.type !== 'COLLECTION' &&
               this.topic.type !== 'PRODUCT_SOURCE' &&
               this.permissionService.currentUserCanManageStream(this.topic);
    }

    canEditTopic = (): boolean => {
        return this.topic &&
               this.topic.tenantId &&
               this.topic.tenantId === this.tenant.id &&
               this.topic.type === 'COLLECTION' &&
               this.permissionService.currentUserCanManageStream(this.topic);
    }

    showJam(): void {
        this.bottomSheet.open(JamBottomSheetComponent, { 
            data: { conversationUrl: this.topic.conversationUrl },
            panelClass: 'jam-bottom-sheet' 
        });
    }

    ngOnInit() {
        this.tenantService.getUnauthTenantInfo().pipe(first())
        .subscribe(tenant => {
            this.tenant = tenant;
            this.showFollowers =  tenant.settings.showFollowers === 'true';
            this.isPublicTenant = tenant.settings.publicTopics === 'true';
        });
    };
}
